const reportWebVitals = (onPerfEntry) => {
  if (!onPerfEntry || !(onPerfEntry instanceof Function)) return;

  import("web-vitals").then((mod) => {
    const callFirst = (fns = []) => {
      for (const fn of fns) {
        if (typeof fn === "function") {
          fn(onPerfEntry);
          return true;
        }
      }
      return false;
    };

    callFirst([mod.onCLS, mod.getCLS]);
    callFirst([mod.onFCP, mod.getFCP]);
    callFirst([mod.onLCP, mod.getLCP]);
    callFirst([mod.onTTFB, mod.getTTFB]);
    // INP replaced FID in newer web-vitals versions; keep a fallback for older exports.
    callFirst([mod.onINP, mod.onFID, mod.getFID]);
  });
};

export default reportWebVitals;
